import { c as _c } from "react/compiler-runtime";
import { useQueryClient } from "@tanstack/react-query";
import { commonApiFetch } from "@/services/api/common-api";
import { ApiWave } from "@/generated/models/ApiWave";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
export const usePrefetchWaveData = () => {
  const $ = _c(2);
  const queryClient = useQueryClient();
  let t0;
  if ($[0] !== queryClient) {
    t0 = waveId => {
      queryClient.prefetchQuery({
        queryKey: [QueryKey.WAVE, {
          wave_id: waveId
        }],
        queryFn: async () => await commonApiFetch({
          endpoint: `waves/${waveId}`
        }),
        staleTime: 60000
      });
    };
    $[0] = queryClient;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const prefetchWaveData = t0;
  return prefetchWaveData;
};